const serviceData = [
  {
    title: "Conference Reviewer",
    items: [
      {
        content: "CHI Conference on Human Factors in Computing Systems (2026)"
      },
      {
        content: "International Conference on Information Systems (2026)"
      },
      {
        content: "Human Factors and Ergonomics Society Annual Meeting (2026)"
      }
    ],
  }
];

export default serviceData;